// extracted by mini-css-extract-plugin
export default {"actions":"ConfirmModal_actions__K+SVp"};